/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        wishlists: 'plus'
    }, window.boostSDAppConfig.integration || {});
}

/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function checkOptionIsAvailable(option, data) {
    let variants = data.variants;
    let is_available = false;
    for (let i = 0; i < variants.length; i++) {
        const splitTitle = variants[i].title.split(' / ');
        if (splitTitle.includes(option) && variants[i].available) {
            return true;
        }
    }
    return is_available;
}

const boost_sd_customize = {
    update: (componentRegistry) => {
        componentRegistry.useComponentPlugin('QuickView', {
            name: 'Modify Product Swatches',
            enabled: true,
            apply: () => ({
                props (props, element) {
                    try {
                        const productData = props.productData;
                        if (productData) {
                            productData.variants.sort(function(a, b) {
                                return b.available - a.available;
                            })
                        }
                    } catch(error) {
                        console.warn(error);
                    }
                  
                    return props;
                }
            })
        });
        /* start Custom Swatches on Product List #218972 */
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'Modify Product Swatches',
            enabled: true,
            apply: () => ({
                props (props, element) {
                    try {
                        const productData = element.getParentElm().getParams().props.productData;

                        if (productData && element.getParams().props.isQuickView) {
                            productData.variants.sort(function(a, b) {
                                return b.available - a.available;
                            })
                            if (typeof productData.variants[0] !== 'undefined' && productData.variants[0]['available']) {
                                const firstVariantAvailable = productData.variants[0];
                                for (let i = 0; i < firstVariantAvailable.merged_options.length; i++) {
                                    const option = firstVariantAvailable.merged_options[i].split(':');
                                    props.options.forEach(function(item, i) {
                                        if (item.value === option[option.length - 1]) {
                                            props.defaultSelectedValue = item.value;
                                        }
                                    });
                                }
                            }
                        }
                    } catch(error) {
                        console.warn(error);
                    }
                  
                    return props;
                },
                afterRender(element) {
                    try {
                        // Reupdate variant image by using metafield value
                        let productData = null;
                        let propOptions = null;
                        let itemEls = null;

                        if (element.getParams().props.isQuickView) {
                            productData = element.getParentElm().getParams().props.productData;
                            propOptions = element.getParams().props.options;
                            itemEls = document.querySelectorAll('.boost-sd__quick-view[product-id="' + productData.id + '"]');

                            // Swatches
                            for (let i = 0; i < propOptions.length; i++) {
                                const option = propOptions[i];
                                let optionImageBg = null;
                                if (option.labelAs == 'image') {
                                    const optionValue = option.value;
                                    const foundVariant = productData.variants.filter(function(e) {
                                        const splitTitle = e.title.split(' / ');
                                        return splitTitle.includes(optionValue);
                                    })
                                    if (typeof foundVariant[0] !== 'undefined' && foundVariant[0]?.image && foundVariant[0]['image'] !== null) {
                                        optionImageBg = foundVariant[0]['image'];
                                    }

                                    itemEls.forEach(function(el) {
                                        let itemEl = el;
                                        let itemQuickViewOptionElLabel = itemEl.querySelector('[value="' + propOptions[i].value + '"] + label');
                                        if (itemQuickViewOptionElLabel != null && itemQuickViewOptionElLabel != undefined) {
                                            itemQuickViewOptionElLabel.style.backgroundImage = "url(" + optionImageBg + ")";
                                        }
                                    });
                                }

                                if (!checkOptionIsAvailable(propOptions[i].value, productData)) {
                                    itemEls.forEach(function(el) {
                                        let itemEl = el;
                                        let itemOptionEl = itemEl.querySelector('[value="' + propOptions[i].value + '"]');
                                        if (itemOptionEl != null && itemOptionEl != undefined) {
                                            itemOptionEl.disabled = "disabled";
                                        }
                                    });
                                }
                            }

                            // Discount
                            const discountPercent = productData.percent_sale_min;
                            const discountHtml = '<span class="boost-sd__quick-view-discount" style="color: rgb(0, 104, 180); font-family: Lato; font-style: normal; font-weight: 700; font-size: 14px;">' + discountPercent + '% Off</span>';
                            itemEls.forEach(function(el) {
                                let itemEl = el;
                                let itemQuickViewPrice = itemEl.querySelector('.boost-sd__quick-view-price');
                                if (itemQuickViewPrice != null && itemQuickViewPrice != undefined && itemEl.querySelector('.boost-sd__quick-view-discount') == null) {
                                    itemQuickViewPrice.insertAdjacentHTML('beforeend', discountHtml);
                                }
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            })
        });
    },
};



window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    boost_sd_customize.update,
]);